import { Helmet } from 'react-helmet-async';
import BodyHeader from './body-header';
import DrawResult from './draw-result';
import Provider from './provider';

function RNG() {
  return (
    <Provider>
    <>
      <Helmet>
        <title> RNG </title>
      </Helmet>
      <BodyHeader />
      <DrawResult />
    </>
    </Provider>
  );
}

export default RNG;
